<template lang="pug">
  div.users-list__container
    template(
      v-for="user in users"
    )
      the-user(
        :user="user"
        :appName="appName"
        :availableRoles="availableRoles"
      )

</template>

<script>
import TheUser from './TheUser.vue';

export default {
  name: 'UsersList',

  components: {
    TheUser,
  },

  props: {
    users: {
      type: Array,
      required: true,
    },

    appName: {
      type: String,
      required: true,
    },

    availableRoles: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .users-list__container {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/UsersList.vue